import { postUrl } from '../fetch';

export interface IPhoneAuthResponse {
    success: boolean;
    token: string;
    borrower: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        mobilePhone: string;
    };
}

export async function phoneAuthLogin(
    token: string
): Promise<IPhoneAuthResponse | undefined> {
    const url = '/api/user/phone-auth-login';

    console.log('phoneAuthLogin - calling API with token:', token);

    const response = await postUrl<IPhoneAuthResponse>(url, { token });

    console.log('phoneAuthLogin - response:', response);

    if (response) {
        return response;
    } else {
        console.error('Error phone auth login:', response);
        return undefined;
    }
}
